@let userCanGetTasks = userCanGetTasks$ | async;
@let userNotReadyReasonHint = userNotReadyReasonHint$ | async;

@if (showAvailabilityState$ | async) {
  <div [ngClass]="{ selectable: userCanGetTasks }" class="availability-state">
    <nimbus-user-tp-capacity-button></nimbus-user-tp-capacity-button>
    <span class="state-content">
      {{ (userCanGetTasks ? TranslationKeys.GeneralReachabilityReady : TranslationKeys.GeneralReachabilityNotReady) | translate }}

      @if (userNotReadyReasonHint) {
        <nimbus-tooltip [text]="userNotReadyReasonHint" />
      }
    </span>
  </div>
}
